import React from "react";
import { usePagination, DOTS } from "../../lib/usePagination";
import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

import { memo } from "react";
import PaginationMaterial from "components/Pagination/Pagination.js";
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Pagination = (props) => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const {
		onPageChange,
		totalCount,
		siblingCount = 2,
		currentPage,
		pageSize,
	} = props;

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize,
	});

	if (currentPage === 0 || paginationRange.length < 2) {
		return null;
	}

	const onNext = () => {
		onPageChange(currentPage + 1);
	};

	const onPrevious = () => {
		onPageChange(currentPage - 1);
	};

	let lastPage = paginationRange[paginationRange.length - 1];

	return (
		<div className={classNames(classesCSStyles.btnGroup)}>
			<PaginationMaterial
				className={classNames(classesCSStyles?.my10)}
				pages={[
					{
						text: <ArrowLeft />,
						onClick: onPrevious,
						disabled: currentPage === 1,
					},
					...paginationRange.map((pageNumber) =>
						typeof pageNumber === "number"
							? {
									text: pageNumber.toString(), // Ensure the text is a string, not a number
									active: pageNumber === currentPage,
									onClick: () => onPageChange(pageNumber),
							  }
							: {
									text: "...",
									disabled: true,
							  }
					),
					{
						text: <ArrowRight />,
						onClick: onNext,
						disabled: currentPage === lastPage,
					},
				]}
				color="info"
			/>
		</div>
	);
};

export default memo(Pagination);
